module.exports = [
  {
    id: 1,
    label: '台南第六選區綠到出汁\n柱柱姐能破鐵桿泛綠？',
    title: '台南第六選區綠到出汁\n柱柱姐能破鐵桿泛綠？',
    description: '「台南市」向來被視為「綠到出汁」的選舉區，不過，從歷年藍綠政治版圖的變化，曾任國民黨主席的洪秀柱要挑戰當地第六選區，只要能破解過去十年這選區被綠化的原因，提高催票率，仍有機會一搏，寫下歷史。',
    image: require('@/assets/articles/article-1-cover.jpg')
  },
  {
    id: 2,
    label: '洪秀柱要創奇蹟\n要先拿下這些搖擺里',
    title: '洪秀柱要創奇蹟\n要先拿下這些搖擺里',
    description: '洪秀柱投入台南市第六選區的立委選戰，短短不到200天的時間，想要打翻綠汁，用藍墨寫下奇蹟，可從仁德區仁和里這個藍營精神堡壘出發，然後站穩藍綠搖擺的東區12里，再一步步逼進深綠選區。',
    image: require('@/assets/articles/article-2-cover.jpg')
  },
  {
    id: 3,
    label: '王定宇、彭文正 綠營鬧分裂\n極統vs極獨 洪秀柱求逆轉勝',
    title: '王定宇、彭文正 綠營鬧分裂\n極統vs極獨 洪秀柱求逆轉勝',
    description: '國民黨提名前主席洪秀柱參選台南市立委，對上本屆第一高票的民進黨現任立委王定宇，洪秀柱若是能打一場「空戰+陸戰」，加上綠營可能面臨分裂的局勢，最後有機會逆轉藍綠勢力。',
    image: require('@/assets/articles/article-3-cover.jpg')
  }
]
